<template>
  <div class="header-wrapper">
    <!-- 顶部栏 -->
    <div class="headertop">
      <div class="headtop hc-container">
        <!-- 未登录 -->
        <div class="login" v-if="!isLogin">
          <p class="hc-color" @click="HcGo('/login')">请登录</p>
          <p @click="HcGo('/register')">免费注册</p>
        </div>

        <!-- 已登录（预留） -->
        <div class="login" v-else>
          <p>
            欢迎您，{{ userInfo.name }}
            <span v-if="vipText" class="vip-tag" :class="'vip-' + userInfo.regtype">
              {{ vipText }}
            </span>
          </p>
          <p class="hc-color" @click="HcGo('/user/index')">个人中心</p>

          <p @click="Loginout()" :disabled="logouting">安全退出</p>
        </div>
      </div>
    </div>

    <!-- 主导航 -->
    <div class="header">
      <div class="head hc-container">
        <!-- Logo -->
        <div class="logo" @click="HcGo('/')">
          <img src="@/assets/images/logo.png" alt="logo" />
        </div>

        <!-- 搜索 -->
        <div class="bigsearch">
          <div class="bigsearch-w">
            <el-input v-model.trim="search.keyword" placeholder="请输入内容" class="bigsearch-input" clearable @keyup.enter.native="handleSearch"> </el-input>
            <!-- 底部HOT搜索 -->
            <div class="hotsearch">
 

  <div class="cate-scroll">
    <!-- 左箭头 -->
    <i class="el-icon-d-arrow-left arrow" @click="scrollCate('left')"></i>

    <!-- 可滚动区域 -->
    <div class="cate-box" ref="cateBox">
      <span @click="changeCate(0)">全部</span>

      <span
        v-for="(item, index) in catelists"
        :key="item.id"
        @click="changeCate(item.id)"
        :class="{ active: search.typeId == item.id }"
      >
        {{ item.name }}
      </span>
    </div>

    <!-- 右箭头 -->
    <i class="el-icon-d-arrow-right arrow" @click="scrollCate('right')"></i>
  </div>
</div>
          </div>

          <el-button icon="el-icon-search" class="searchbtn" @click="handleSearch" />
        </div>

        <!-- 购物车 -->
        <div class="cart" @click="HcGo('/cart')">
          <img src="@/assets/images/cart.png" alt="cart" />
          <p>
            书篮 <span>{{ cartCount }}</span> 件
          </p>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "HeaderBar",

  data() {
    return {
      logouting: false,
      search: {
        keyword: "",
        type: "",
      },
    };
  },

  computed: {
    /** 登录态（统一入口） */
    ...mapGetters("user", ["isLogin"]),

    /** 用户信息 */
    ...mapState("user", ["userInfo"]),
    catelists() {
      return this.$store.state.book.bookCate || [];
    },
    /** 购物车数量 */
    cartCount() {
      return this.$store.state.cart.cart.length;
    },
    vipText() {
      const map = {
        1: "甲",
        2: "乙",
        3: "丙",
        4: "丁",
      };
      return map[this.userInfo.regtype] || "";
    },
  },

  methods: {
    scrollCate(dir) {
    const box = this.$refs.cateBox;
    if (!box) return;

    const step = 150;

    if (dir === "left") {
      box.scrollLeft -= step;
    } else {
      box.scrollLeft += step;
    }
  },
    async Loginout() {
      await this.$store.dispatch("user/logout");

      if (this.$store.getters["user/isLogin"]) {
        await this.$store.dispatch("cart/fetchCart");
      } else {
        this.$store.commit("cart/SET_CART", []);
      }

      this.$message.success("退出成功");
      this.$router.push("/");
    },
    changeCate(id) {
      const query = { ...this.$route.query };

      if (!id || id === 0) {
        // 全部分类：移除 typeId
        delete query.typeId;
      } else {
        query.typeId = id;
      }

      // 如果参数没变化，不跳转（避免重复刷新）
      if (JSON.stringify(query) === JSON.stringify(this.$route.query)) return;

      this.$router.push({
        path: "/book_lists",
        query,
      });
    },

    handleSearch() {
      // if (!this.search.keyword) {
      //   this.$message.warning("请输入搜索内容");
      //   return;
      // }

      this.$router.push({
        path: "/book_lists",
        query: {
          keyword: this.search.keyword.trim(),
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
.headertop {
  width: 100%;
  height: 40px;
  background: #ffffff;
  box-shadow: 0px 1px 5px 0px rgba(108, 90, 38, 0.1);
  .headtop {
    width: 100%;
    height: 40px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .login {
      display: flex;
      font-size: 16px;
      p {
        margin-left: 15px;
        cursor: pointer;
        font-size: 16px !important;
        color: #514528;
      }
    }
  }
}
.header {
  width: 100%;
  height: 160px;
  box-sizing: border-box;
  background: url(../../assets/images/nav.png) no-repeat top center;
  background-size: cover;
  .head {
    width: 100%;
    height: 160px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo {
      cursor: pointer;
    }
    .cart {
      position: relative;
      min-width: 186px;
      max-width: 300px;
      height: 48px;
      border-radius: 4px;
      border: 2px solid rgba(202, 194, 184, 0.5);
      padding: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      overflow: hidden;
      transition: all 0.35s ease;

      /* 悬浮抬升 */
      &:hover {
        border-color: #f0b916;
        transform: translateY(-3px);
        box-shadow: 0 8px 20px rgba(240, 185, 22, 0.25);
      }

      /* 流光层 */
      &::before {
        content: "";
        position: absolute;
        top: -50%;
        left: -50%;
        width: 200%;
        height: 200%;
        background: linear-gradient(120deg, transparent 30%, rgba(240, 185, 22, 0.5), transparent 70%);
        transform: rotate(25deg) translateX(-100%);
        transition: transform 0.6s ease;
        pointer-events: none;
      }

      &:hover::before {
        transform: rotate(25deg) translateX(100%);
      }

      img {
        transition: transform 0.3s ease;
      }

      &:hover img {
        transform: scale(1.1);
      }
    }

    .bigsearch {
      width: 715px;
      height: 48px;
      background-color: #f0b916;
      border-radius: 8px;
      padding: 3px 5px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &-w {
        width: 100%;
        height: 42px;
        border-radius: 8px;
        background-color: #fff;

        padding: 1px 2px;

        /deep/ .el-input__inner {
          border: 0px !important;
        }
        .hotsearch {
          width: 760px!important;
          display: flex;
          color: #999;
          align-items: center;
          padding-top: 15px;
          p {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            span {
              margin: 0px 10px;
              cursor: pointer;
              &:hover {
                color: #f0b916;
              }
            }
          }
        }
      }
      .searchbtn {
        border: 0px;
        color: #fff;
        font-size: 20px;
        background-color: #f0b916 !important;
      }
    }
  }
}
.vip-tag {
  margin-left: 6px;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  color: #fff;
}

/* 不同等级颜色 */
.vip-1 {
  background: linear-gradient(45deg, #e6a23c, #f3d19e);
}

.vip-2 {
  background: linear-gradient(45deg, #409eff, #66b1ff);
}

.vip-3 {
  background: linear-gradient(45deg, #67c23a, #95d475);
}

.vip-4 {
  background: linear-gradient(45deg, #909399, #606266);
}
.cate-scroll {
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.arrow {
  width: 24px;
  height: 24px;
  cursor: pointer;
  color: #999;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #f0b916;
  }
}

.cate-box {
  flex: 1;
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  scroll-behavior: smooth;
  padding: 0 5px;

  /* 隐藏滚动条 */
  &::-webkit-scrollbar {
    display: none;
  }

  span {
    flex-shrink: 0;
    margin: 0 10px;
    cursor: pointer;
    color: #666;

    &:hover {
      color: #f0b916;
    }

    &.active {
      color: #f0b916;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue